<div class="mb-4 d-flex-between">
  <div class="d-grid">
    <h3 class="mb-0">{{ "icd-codes.often-used.page-title" | translate }}</h3>
    <p>{{ "icd-codes.often-used.page-description" | translate }}</p>
  </div>
</div>

<div class="row">
  <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
    <div>
      <app-cards
        [title]="'icd-codes.often-used.group-header' | translate"
        footerDivider="border-0 pb-0 "
        class="custom-cardbox-area"
        styleBody="px-0"
      >
        <div headerRight class="d-flex">
          <button class="btn btn-primary ms-2" (click)="addGroup()">
            {{ "icd-codes.often-used.group-add-button" | translate }}
          </button>
        </div>
        <div bodyContent>
          <div class="px-3 mb-4">
            <input
              type="search"
              class="form-control"
              [placeholder]="'common.search' | translate"
              [(ngModel)]="groupFilter"
              (input)="onGroupFilter()"
            />
          </div>
          <ng-container>
            <div style="height: 60vh; overflow-y: auto">
              <div
                *ngIf="filteredGroupList?.length === 0"
                class="text-center text-muted py-3"
              >
                {{ "common.noData" | translate }}
              </div>
              <div
                class="d-flex align-items-center justify-content-between custom-hover"
                *ngFor="let item of filteredGroupList"
                [ngClass]="{
                  'left-line-active': item?.id === selectedGroup?.id,
                  'bg-color': item?.id === selectedGroup?.id
                }"
              >
                <button
                  class="p-3 btn text-start flex-grow-1"
                  (click)="selectItem(item)"
                >
                  <div class="item-name mb-1">{{ item.name }}</div>
                  <div class="text-muted small">{{ item.description }}</div>
                </button>

                <div class="d-flex flex-nowrap">
                  
                    <i class="pi pi-pencil edit-history-action-icon" (click)="addGroup(item)"></i>
                 
                    <i class="pi pi-trash trash-delete-icon" (click)="deleteGroupeAlert(item)"></i>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </app-cards>
    </div>
  </div>

  <div class="col-lg-8 col-md-6 col-sm-12 mb-4">
    <div>
      <app-cards
        [title]="'icd-codes.often-used.icd-code-header' | translate"
        footerDivider="border-0 pb-0 "
        styleBody="px-0"
        class="custom-cardbox-area"
      >
        <div headerRight class="d-flex">
          <button
            class="btn btn-primary ms-2"
            [disabled]="!selectedGroup"
            (click)="openIcdCodePopup()"
          >
            {{ "icd-codes.often-used.icd-code-add-button" | translate }}
          </button>
        </div>
        <div bodyContent>
          <div class="px-3 mb-4">
            <input
              type="search"
              class="form-control"
              [placeholder]="'common.search' | translate"
              [(ngModel)]="codeFilter"
              (input)="onCodeFilter()"
            />
          </div>
          <ng-container>
            <div style="height: 60vh; overflow-y: auto">
              <div
                *ngIf="icdCodes?.length === 0"
                class="text-center text-muted py-3"
              >
                {{ "common.noData" | translate }}
              </div>
              <div
                class="d-flex align-items-center justify-content-between"
                *ngFor="let code of icdCodes"
              >
                <div class="p-3 text-start flex-grow-1">
                  <div class="item-name mb-1">{{code?.code}} - {{ code?.name }}</div>
                </div>

                <div class="d-flex flex-nowrap">
                    <i class="pi pi-trash trash-delete-icon" (click)="deleteICDCodeAlert(code)"></i>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </app-cards>
    </div>
  </div>
</div>

<app-core-popup
  [dialogStyle]="{ width: '45rem' }"
  [header]="'icd-codes.often-used.add-group.header' | translate"
  (closeOn)="onGroupPopupClosed()"
  [saveText]="(mode === 'edit' ? 'common.update' : 'common.save') | translate"
  (chooseOn)="mode === 'edit' ? updateGroup() : saveGroup()"
  #popup
>
  <div class="container">
    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label required-star" for="">
          {{ "icd-codes.often-used.add-group.group-name" | translate }}:
        </label>
      </div>
      <div class="col-md-9">
        <input type="text" class="form-control col-7" [(ngModel)]="form.name" />
        <div *ngIf="isSubmit && form.name === ''" class="required">
          {{ "validation.required" | translate }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label" for="">
          {{ "icd-codes.often-used.add-group.group-description" | translate }}:
        </label>
      </div>
      <div class="col-md-9">
        <textarea
          class="form-control"
          [(ngModel)]="form.description"
        ></textarea>
      </div>
    </div>
  </div>
</app-core-popup>

<app-icd-codes-popup
  (saveOn)="icdCodeSave($event)"
  [showOftenUsage]="false"
  #icdCodePopup
></app-icd-codes-popup>

<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
